import MapState from '../interfaces/states/MapState';

import * as Const from '../constants';

const initState: MapState = {
  isError: false,
  isLoading: false,
  isShowMap: false,
  mapInfo: {
    data: [],
  },
};

export default function map (state: MapState = initState, action): MapState {
  switch (action.type) {

    case Const.FETCH_MAP_INIT:
      return {
        ...initState,
        isLoading: false,
      };

    case Const.FETCH_MAP_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_MAP_SUCCESS:
      return {
        ...state,
        mapInfo: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.FETCH_MAP_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.FETCH_MAP_SHOW:
      return {
        ...state,
        isShowMap: true,
      };

    case Const.FETCH_MAP_HIDE:
      return {
        ...state,
        isShowMap: false,
      };

    default:
      return state;
  }
}
